export const TORRE_LIST_MODE_KEY = 'torre.listMode';

export type TorreListMode = 'compact' | 'spreadsheet';

export function isTorreListMode(value: unknown): value is TorreListMode {
    return value === 'compact' || value === 'spreadsheet';
}

export function readTorreListMode(storage: Pick<Storage, 'getItem'> = sessionStorage): TorreListMode {
    try {
        const raw = storage.getItem(TORRE_LIST_MODE_KEY);
        return isTorreListMode(raw) ? raw : 'compact';
    } catch {
        return 'compact';
    }
}

export function writeTorreListMode(
    mode: TorreListMode,
    storage: Pick<Storage, 'setItem'> = sessionStorage
): void {
    storage.setItem(TORRE_LIST_MODE_KEY, mode);
}
